/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* KL Kuechenhelfer-Trio: Bundle-Auswahl mit Kacheln + Farbauswahl (18.10.2026) – Styles dazu in custom.css (#kl-trio) */
(function () {
  var HANDLE = 'kuchenhelfer-trio-fur-airfryer-olspruher-kuchenzange-ofenhandschuhe';
  if (location.pathname.indexOf('/products/' + HANDLE) === -1) return;

  var CDN = 'https://cdn.shopify.com/s/files/1/0839/3084/1414/files/';
  var HEX = { 'Midnight Black': '#1d1d1d', 'Weiß': '#f3f2ee', 'Stone Grey': '#7f7f7b', 'Cashmere Flow': '#c4b2a0', 'Mint Mellow': '#a7d6be', 'Dusty Rose': '#e2a7b3', 'Blue Heaven': '#63c0e6', 'Spicy Red': '#b1232b' };
  var PARTS = [
    { pos: '1', name: 'Ölsprüher', img: { 'Midnight Black': 'Zeichenflaeche1.webp', 'Weiß': 'Zeichenflaeche_13.webp' } },
    { pos: '2', name: 'Küchenzange', img: { 'Midnight Black': 'Zeichenflaeche4.webp', 'Stone Grey': 'Zeichenflaeche_3_13f5db42-3a28-4d5e-ad77-669116a4dd9f.webp', 'Cashmere Flow': 'Zeichenflaeche_1_10271af7-1039-4c35-96fa-7f025eda50b4.webp', 'Mint Mellow': 'Zeichenflaeche_2_511eb394-f4ee-4867-91d2-c3cbc49fc0db.webp' } },
    { pos: '3', name: 'Ofenhandschuhe', img: { 'Midnight Black': 'Zeichenflaeche7.webp', 'Stone Grey': 'Zeichenflaeche_4_dcfc8dc0-202a-43a0-beef-c8927de5a161.webp', 'Cashmere Flow': 'Zeichenflaeche_6_88a30c49-ed5e-466e-a62c-a774a1a4de69.webp', 'Mint Mellow': 'Zeichenflaeche_2_a3199067-baec-4b27-88d2-22b7960b5f02.webp', 'Dusty Rose': 'Zeichenflaeche_1_f505e5d1-547e-4f13-8656-8f17101b1aec.webp', 'Blue Heaven': 'Zeichenflaeche_3_2a8aae35-1eb4-4804-b5af-8332da2696ed.webp', 'Spicy Red': 'Zeichenflaeche_5_87828581-b0bc-4300-9298-d241ac4c52d4.webp' } }
  ];
  var CHEV = '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 3.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var open = null, root = null, busy = false, lastSig = '';

  function picker() { return document.querySelector('.product__info variant-picker'); }
  function inputs(pos) { var v = picker(); return v ? v.querySelectorAll('input[data-option-position="' + pos + '"]') : []; }
  function labelOf(inp) { return document.querySelector('label[for="' + inp.id + '"]'); }
  function options(p) {
    var list = [];
    Array.prototype.forEach.call(inputs(p.pos), function (inp) {
      var l = labelOf(inp); if (!l) return;
      var sw = inp.closest('.block-swatch');
      list.push({ color: l.textContent.trim(), input: inp, label: l, checked: inp.checked, soldout: !!(sw && sw.classList.contains('is-disabled')) });
    });
    return list;
  }
  function current(p) { var o = options(p).filter(function (x) { return x.checked; })[0]; return o ? o.color : null; }
  function imgUrl(p, c) { return p.img[c] ? CDN + p.img[c] + '?width=300' : ''; }
  function sig() { return PARTS.map(function (p) { return options(p).map(function (o) { return o.color + (o.checked ? '*' : '') + (o.soldout ? '!' : ''); }).join(','); }).join('|'); }

  function build() {
    var v = picker(); if (!v) return false;
    var form = v.parentElement;
    root = document.getElementById('kl-trio');
    if (!root) {
      root = document.createElement('div');
      root.id = 'kl-trio';
      root.innerHTML =
        '<div class="kl-trio__intro"><p class="kl-trio__title">Stell dir dein Set zusammen</p><p class="kl-trio__text">Tippe auf ein Teil und wähle deine Lieblingsfarbe. Du kannst die Farben frei kombinieren.</p></div>' +
        '<div class="kl-trio__tiles" role="group" aria-label="Teile des Sets"></div>' +
        '<div class="kl-trio__panel" hidden><div class="kl-trio__panel-head"><strong></strong><button type="button" class="kl-trio__close">Schließen</button></div><div class="kl-trio__swatches" role="radiogroup"></div></div>' +
        '<p class="kl-trio__summary"></p>';
      form.insertBefore(root, v);
      root.querySelector('.kl-trio__close').addEventListener('click', function () { close(true); });
    } else if (root.nextElementSibling !== v && root.parentElement === form) {
      form.insertBefore(root, v);
    }
    document.documentElement.classList.add('kl-trio-on');
    return true;
  }

  function renderTiles() {
    if (!root) return;
    lastSig = sig();
    var wrap = root.querySelector('.kl-trio__tiles');
    wrap.innerHTML = '';
    PARTS.forEach(function (p, i) {
      var c = current(p) || Object.keys(p.img)[0];
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kl-trio__tile'; b.id = 'kl-trio-tile-' + p.pos;
      b.setAttribute('aria-expanded', open === p.pos ? 'true' : 'false');
      b.innerHTML = '<span class="kl-trio__img"><img alt="' + p.name + ' in ' + c + '" src="' + imgUrl(p, c) + '"></span>' +
        '<span class="kl-trio__name">' + p.name + '</span>' +
        '<span class="kl-trio__color"><span class="kl-trio__dot" style="background:' + (HEX[c] || '#ccc') + '"></span>' + c + '</span>' +
        '<span class="kl-trio__change"><span>Farbe ändern</span>' + CHEV + '</span>';
      b.addEventListener('click', function () { toggle(p, i); });
      wrap.appendChild(b);
    });
    root.querySelector('.kl-trio__summary').innerHTML = 'Dein Set: ' + PARTS.map(function (p) { return '<b>' + p.name + '</b> ' + (current(p) || ''); }).join(' · ');
  }

  function toggle(p, i) {
    if (open === p.pos) { close(false); return; }
    open = p.pos;
    var panel = root.querySelector('.kl-trio__panel');
    panel.querySelector('strong').textContent = 'Farbe für ' + p.name + ' wählen';
    panel.style.setProperty('--kl-arrow', (16.66 + i * 33.33) + '%');
    var sw = panel.querySelector('.kl-trio__swatches');
    sw.innerHTML = '';
    options(p).forEach(function (o) {
      var s = document.createElement('button');
      s.type = 'button'; s.className = 'kl-trio__sw' + (o.soldout ? ' is-soldout' : '');
      s.setAttribute('role', 'radio'); s.setAttribute('aria-checked', o.checked ? 'true' : 'false');
      s.innerHTML = '<span class="kl-trio__ring"><span style="background:' + (HEX[o.color] || '#ccc') + '"></span></span><small>' + o.color + (o.soldout ? '<em>ausverkauft</em>' : '') + '</small>';
      s.addEventListener('click', function () { pick(p, o.color); });
      sw.appendChild(s);
    });
    panel.hidden = false;
    renderTiles();
  }

  function pick(p, color) {
    var o = options(p).filter(function (x) { return x.color === color; })[0];
    open = null;
    root.querySelector('.kl-trio__panel').hidden = true;
    if (o && !o.checked) { busy = true; o.label.click(); busy = false; }
    renderTiles();
    var t = document.getElementById('kl-trio-tile-' + p.pos);
    if (t) { t.classList.remove('is-flash'); void t.offsetWidth; t.classList.add('is-flash'); try { t.focus({ preventScroll: true }); } catch (e) {} }
  }

  function close(focus) {
    var k = open; open = null;
    if (root) root.querySelector('.kl-trio__panel').hidden = true;
    renderTiles();
    if (focus && k) { var t = document.getElementById('kl-trio-tile-' + k); if (t) t.focus(); }
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) close(true); });

  function init() {
    if (!build()) return;
    renderTiles();
    var host = root.closest('product-rerender') || document.body;
    var queued = false;
    new MutationObserver(function (muts) {
      if (busy || queued) return;
      var outside = muts.some(function (m) { return !(root && root.contains(m.target)); });
      if (!outside) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        var rebuilt = !document.getElementById('kl-trio');
        if (rebuilt) root = null;
        if (!build()) return;
        if (!rebuilt && sig() === lastSig) return;
        var wasOpen = open; renderTiles();
        if (wasOpen) { var p = PARTS.filter(function (x) { return x.pos === wasOpen; })[0]; open = null; toggle(p, PARTS.indexOf(p)); }
      });
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* KL Upsell „Dazu passt perfekt“ im More-Look (18.10.2026) */
(function () {
  var SUB = 'Ergänze dein Set mit unseren Lieblingen.';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  function num(el) { if (!el) return 0; var m = (el.textContent || '').replace(/\./g, '').match(/(\d+)(?:,(\d+))?/); return m ? parseFloat(m[1] + '.' + (m[2] || '0')) : 0; }
  function badge(it) {
    var t = num(it.querySelector('.sh-upsell-block-content-item-price-total'));
    var ce = it.querySelector('.sh-upsell-block-content-item-price-compareAt');
    var c = ce && ce.offsetParent !== null ? num(ce) : 0;
    var b = it.querySelector('.kl-up-badge');
    var pct = c > t && t > 0 ? Math.round((1 - t / c) * 100) : 0;
    it.classList.toggle('kl-up-sale', pct > 0);
    if (pct > 0) { if (!b) { b = document.createElement('span'); b.className = 'kl-up-badge'; it.appendChild(b); } b.textContent = '-' + pct + '%'; }
    else if (b) b.remove();
  }
  function enhance(u) {
    var block = u.closest('.sh-block'); if (!block) return;
    var head = block.previousElementSibling;
    if (head && head.classList.contains('product-form__text') && !head.classList.contains('kl-up-head')) {
      head.classList.add('kl-up-head');
      var p = document.createElement('p'); p.className = 'kl-up-sub'; p.textContent = SUB; head.appendChild(p);
    }
    if (!head || !head.classList.contains('kl-up-head')) return;
    u.classList.add('kl-up');
    var items = u.querySelectorAll('.sh-upsell-block-content-item');
    Array.prototype.forEach.call(items, function (it) {
      badge(it);
      if (!it.dataset.klObs) { it.dataset.klObs = 1; new MutationObserver(function () { badge(it); }).observe(it.querySelector('.sh-upsell-block-content-item-price') || it, { childList: true, subtree: true, characterData: true }); }
      var cb = it.querySelector('input[type="checkbox"]'); if (cb && !cb.getAttribute('aria-label')) { var ti = it.querySelector('.sh-upsell-block-content-item-product-content-info-title'); cb.setAttribute('aria-label', (ti ? ti.textContent.trim() : 'Produkt') + ' mit in den Warenkorb legen'); }
    });
    var sl = u.querySelector('.sh-upsell-slider'), sw = sl && sl.swiper;
    if (!sw || u.dataset.klNav) return;
    u.dataset.klNav = 1;
    var multi = items.length > 1;
    sw.params.slidesPerView = multi ? 1.28 : 1; sw.params.spaceBetween = 10; sw.params.autoHeight = false; sw.wrapperEl.style.height = '';
    if (sw.params.breakpoints) sw.params.breakpoints = {};
    sw.update();
    if (!multi) return;
    var nav = document.createElement('div'); nav.className = 'kl-up-nav';
    nav.innerHTML = '<button type="button" class="kl-up-prev" aria-label="Vorheriges Produkt">' + ARROW + '</button><button type="button" class="kl-up-next" aria-label="Nächstes Produkt" style="transform:scaleX(-1)">' + ARROW + '</button>';
    sl.parentNode.insertBefore(nav, sl.nextSibling);
    var prev = nav.children[0], next = nav.children[1];
    prev.addEventListener('click', function () { sw.slidePrev(); });
    next.addEventListener('click', function () { sw.slideNext(); });
    function st() { prev.disabled = sw.isBeginning; next.disabled = sw.isEnd; }
    sw.on('slideChange', st); sw.on('reachEnd', st); sw.on('reachBeginning', st); st();
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('sh-upsell'), enhance); }
  var tries = 0;
  (function wait() { run(); var pending = !document.querySelector('sh-upsell') || Array.prototype.some.call(document.querySelectorAll('sh-upsell'), function (u) { return !u.dataset.klNav; }); if (pending && tries++ < 60) setTimeout(wait, 250); })();
  document.addEventListener('shopify:section:load', run);
})();

/* KL Upsell v2: Direkt-Kauf, Überschriften & Nutzen-Texte (18.10.2026) */
(function () {
  /* Upsell-Produkt: [Kurztitel, Nutzen] */
  var P = {
    'olspruher-2-in-1': ['Ölsprüher 2-in-1', 'Sprühen oder gießen – bis zu 80 % weniger Öl.'],
    'ofenhandschuhe-2er-set': ['Ofenhandschuhe 2er-Set', 'Heißen Korb sicher greifen – Schutz bis 240 °C.'],
    'kuchenzange-2er-set': ['Küchenzange 2er-Set', 'Wenden ohne Kratzer dank Silikon-Köpfen.'],
    '3er-set-silikonformen-heissluftfritteuse-airfryer': ['Silikonformen 3er-Set', 'Nichts klebt an, kein Schrubben – ohne Einfetten.'],
    'waffeleinsatz-aus-bpa-freiem-silikon': ['Waffeleinsatz', 'Frische Waffeln in ca. 8 Minuten – ohne Waffeleisen.'],
    'starter-bundle-eckige-heissluftfritteuse-faltbar': ['Faltbare Formen eckig', 'Für eckige Airfryer ab 3,7 L – faltbar & platzsparend.'],
    'silikonform-ninja-foodi-dual-zone-faltbar': ['Faltbare Formen Dual Zone', 'Für beide Zonen – faltbar & platzsparend.'],
    'airfryer-backpapier-eckig-naturfaserzellstoff': ['Backpapier eckig', 'Einlegen, garen, wegwerfen – der Korb bleibt sauber.'],
    'airfryer-backpapier-eckig': ['Backpapier Dual Zone', 'Passgenau geformt – kein Zuschneiden, kein Schrubben.'],
    'backpapier-fur-ninja-flexdrawer-af500-eu': ['Backpapier XXL', 'Für große Schubladen – der Korb bleibt sauber.'],
    'ninja-heissluftfritteuse-zubehor-set-xxl': ['Ninja Zubehör-Set XXL', 'Komplett ausgestattet für Dual-Airfryer 7,6–9,5 L.'],
    'xxl-zubehor-set-ninja-flexdrawer-af500': ['XXL-Set Ninja AF500', '14 Teile für die ganze Schublade und beide Zonen.'],
    'xl-zubehor-set-fur-ninja-foodi-kopie': ['XL Zubehör-Set Ninja 12-tlg.', 'Edelstahl-Zubehör für Dual-Airfryer 7,6–9,5 L.'],
    'ninja-rezeptbuch-airfryingkowa-e-book': ['Ninja-Rezeptbuch Airfryingkowa', 'Die beliebten Kowa-Rezepte als PDF – 173 Seiten.']
  };
  /* Produktgruppe: [Überschrift, Unterzeile] */
  var G = {
    oel: ['Mach dein Airfryer-Set komplett', 'Backpapier, Formen & Handschuhe – die perfekte Ergänzung zum Ölsprüher.'],
    helfer: ['Dein Küchenhelfer-Upgrade', 'Backpapier rein, wenden, sicher herausnehmen – alles passt zusammen.'],
    waffel: ['Noch mehr Ideen für deinen Airfryer', 'Vom Waffel-Frühstück bis zum Auflauf am Abend.'],
    formen: ['Dein Knusper-Upgrade', 'Weniger Öl, sicherer Griff, sauberer Korb – passend zu deinen Formen.'],
    papier: ['Dein Airfryer-Upgrade', 'Wiederverwendbare Formen und Extras – für noch mehr Knusper.'],
    sets: ['Die Extras für jeden Tag', 'Backpapier, Ölsprüher & mehr – damit Kochen und Reinigen noch leichter wird.'],
    ebook: ['Alles für deine ersten Rezepte', 'Mit dem passenden Zubehör gelingen die Rezepte noch leichter.'],
    trio: ['Dein Trio, noch vielseitiger', 'Formen, Backpapier & Waffeln – für noch mehr Abwechslung.'],
    komplettset: ['Noch mehr aus deinem Set holen', 'Extras, die noch nicht im Set sind – perfekt dazu.']
  };
  var PAGE = {
    'olspruher-2-in-1': 'oel', 'ofenhandschuhe-2er-set': 'helfer', 'kuchenzange-2er-set': 'helfer', 'waffeleinsatz-aus-bpa-freiem-silikon': 'waffel',
    '3er-set-silikonformen-heissluftfritteuse-airfryer': 'formen', 'silikonform-ninja-foodi-dual-zone-faltbar': 'formen', 'starter-bundle-fur-dual-zone': 'formen',
    '2er-set-silikonformen-fur-dual-zone': 'formen', 'starter-bundle-eckige-heissluftfritteuse-faltbar': 'formen', '2er-set-silikonform-philips-dual-basket-airfryer-3000-5000-serie': 'formen',
    'silikonformen-fur-ninja-sl400-sl451': 'formen', 'starter-bundle-fur-ninja-af400-faltbar': 'formen',
    'airfryer-backpapier-eckig': 'papier', 'airfryer-backpapier-eckig-naturfaserzellstoff': 'papier', 'airfryer-backpapier-rund-16-20cm': 'papier', 'backpapier-fur-ninja-flexdrawer-af500-eu': 'papier',
    'xxl-zubehoer-set-heissluftfritteuse-16-teilig': 'sets', 'xl-zubehor-set-fur-ninja-foodi-kopie': 'sets', 'xxl-zubehor-set-ninja-flexdrawer-af500': 'sets', 'ninja-heissluftfritteuse-zubehor-set-xxl': 'sets',
    'airfryer-rezeptbuch-e-book': 'ebook', 'ninja-rezeptbuch-airfryingkowa-e-book': 'ebook',
    'kuchenhelfer-trio-fur-airfryer-olspruher-kuchenzange-ofenhandschuhe': 'trio',
    'komplett-set-ninja-af500': 'komplettset', 'komplett-set-ninja-af400': 'komplettset', 'komplett-set-eckige-airfryer': 'komplettset', 'komplett-set-xxl-eckige-airfryer': 'komplettset', 'komplett-set-plus-ninja-af400': 'komplettset', 'komplett-set-plus-eckige-airfryer': 'komplettset', 'komplett-set-ninja-sl400': 'komplettset'
  };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var page = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];

  function setup(u) {
    if (u.dataset.klV2 || !u.classList.contains('kl-up')) return;
    u.dataset.klV2 = 1;
    var head = u.closest('.sh-block').previousElementSibling, g = G[PAGE[page]];
    if (g && head) {
      var h1 = head.querySelector('p:not(.kl-up-sub)'), sub = head.querySelector('.kl-up-sub');
      if (h1) h1.textContent = g[0];
      if (sub) sub.textContent = g[1];
    }
    Array.prototype.forEach.call(u.querySelectorAll('.sh-upsell-block'), function (b) {
      var h = b.dataset.productHandle, d = P[h], it = b.querySelector('.sh-upsell-block-content-item');
      if (!it) return;
      var url = root + 'products/' + h;
      var ti = it.querySelector('.sh-upsell-block-content-item-product-content-info-title');
      if (ti) { var name = d ? d[0] : ti.textContent.trim(); ti.textContent = ''; var a = document.createElement('a'); a.href = url; a.textContent = name; ti.appendChild(a); }
      if (d && !it.querySelector('.kl-up-desc')) { var s = document.createElement('p'); s.className = 'kl-up-desc'; s.textContent = d[1]; it.appendChild(s); }
      var img = it.querySelector('.sh-upsell-block-content-item-product-content-image');
      if (img) img.addEventListener('click', function () { location.href = url; });
      var cb = it.querySelector('input[type="checkbox"]');
      if (cb) { cb.checked = false; cb.setAttribute('aria-label', (d ? d[0] : 'Produkt') + ' in den Warenkorb legen'); }
      it.classList.toggle('kl-up-soldout', b.dataset.variantAvailable === 'false');
    });
  }

  function add(inp) {
    var box = inp.parentElement, b = inp.closest('.sh-upsell-block');
    if (!b || box.classList.contains('kl-up-busy')) return;
    var id = b.dataset.variantId;
    if (!id || b.dataset.variantAvailable === 'false') return;
    box.classList.remove('kl-up-done', 'kl-up-err'); box.classList.add('kl-up-busy'); if (window.klUpFly) window.klUpFly(box);
    var mc = document.getElementById('mini-cart'), sec = mc && mc.getAttribute('section');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (sec) { body.sections = sec; body.sections_url = location.pathname; }
    window.klNativeFetch()(location.origin + root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        
        if (window.upcartRefreshCart) { try { window.upcartRefreshCart(); } catch (e) {} } return window.klNativeFetch()(location.origin + root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (j.sections) cart.sections = j.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: false } }));
        });
      })
      .then(function () { box.classList.remove('kl-up-busy'); box.classList.add('kl-up-done'); setTimeout(function () { box.classList.remove('kl-up-done'); }, 2200); })
      .catch(function () { box.classList.remove('kl-up-busy'); box.classList.add('kl-up-err'); setTimeout(function () { box.classList.remove('kl-up-err'); }, 2200); });
  }

  document.addEventListener('click', function (e) {
    var inp = e.target && e.target.closest && e.target.closest('.kl-up .sh-upsell-block-content-item-checkbox input');
    if (!inp) return;
    e.preventDefault(); e.stopImmediatePropagation();
    add(inp);
  }, true);

  var tries = 0;
  (function wait() {
    Array.prototype.forEach.call(document.querySelectorAll('sh-upsell.kl-up'), setup);
    var pending = !document.querySelector('sh-upsell.kl-up') || document.querySelector('sh-upsell.kl-up:not([data-kl-v2])');
    if (pending && tries++ < 60) setTimeout(wait, 250);
  })();
})();

/* KL Upsell: Produkt fliegt in den Warenkorb (18.10.2026) */
(function () {
  function target() {
    var list = document.querySelectorAll('a[aria-controls="mini-cart"], cart-count');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return list[i].closest('a') || list[i];
    }
    return null;
  }
  function bump(el) {
    if (!el || !el.animate) return;
    el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(.92)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'ease-out' });
  }
  window.klUpFly = function (box) {
    var it = box.closest('.sh-upsell-block-content-item');
    var img = it && it.querySelector('.sh-upsell-block-content-item-product-content-image img');
    var t = target();
    if (!img || !t) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !document.body.animate) { setTimeout(function () { bump(t); }, 300); return; }
    var a = img.getBoundingClientRect(), b = t.getBoundingClientRect();
    var size = Math.min(a.width, a.height, 72);
    var ghost = img.cloneNode(true);
    ghost.removeAttribute('srcset'); ghost.removeAttribute('loading');
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.cssText = 'position:fixed;z-index:2147483000;pointer-events:none;margin:0;object-fit:contain;background:#fff;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.22);' +
      'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
    document.body.appendChild(ghost);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var lift = Math.min(120, Math.abs(dy) * 0.35 + 40);
    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - lift) + 'px) scale(.8)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.18)', opacity: .35 }
    ], { duration: 780, easing: 'cubic-bezier(.45,.05,.55,.95)', fill: 'forwards' });
    anim.onfinish = function () { ghost.remove(); bump(t); };
    setTimeout(function () { if (ghost.parentNode) ghost.remove(); }, 1500);
  };
})();

/* KL Upsell: eigener fetch, damit UpCart beim Upsell nicht automatisch aufklappt (18.10.2026) */
window.klNativeFetch = function () {
  if (window.__klNF) return window.__klNF;
  try {
    var f = document.createElement('iframe');
    f.style.display = 'none'; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1;
    document.body.appendChild(f);
    window.__klNF = f.contentWindow.fetch.bind(f.contentWindow);
  } catch (e) { window.__klNF = window.fetch.bind(window); }
  return window.__klNF;
};

/* KL Produktseite mobil: Kategorie-Leiste direkt kompakt (18.10.2026) */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var sec = document.querySelector('[id^="shopify-section-"][id*="story_slider"]');
  return; /* KL 23.10.: deaktiviert, Bubbles ueberall gross */
  var mq = window.matchMedia('(max-width: 749px)');
  function apply() {
    if (mq.matches) { sec.classList.add('kl-pdp-compact'); if (!sec.classList.contains('kl-stuck')) sec.classList.add('kl-stuck'); }
    else sec.classList.remove('kl-pdp-compact');
  }
  new MutationObserver(function () { if (mq.matches && !sec.classList.contains('kl-stuck')) sec.classList.add('kl-stuck'); }).observe(sec, { attributes: true, attributeFilter: ['class'] });
  if (mq.addEventListener) mq.addEventListener('change', apply);
  apply();
})();

/* KL Produktgalerie mobil: Pfeile links/rechts wie More (18.10.2026) */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  return; /* Pfeile deaktiviert 18.10.2026 */
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="PATH"/></svg>';
  function setup() {
    var fc = document.querySelector('.product__media flickity-carousel.product__media-list');
    if (!fc || fc.dataset.klArrows) return;
    var wrap = fc.closest('.product__media-list-wrapper');
    if (!wrap || !fc.flickityInstance) return;
    fc.dataset.klArrows = '1';
    Promise.resolve(fc.flickityInstance).then(function (fi) {
      if (!fi || !fi.cells || fi.cells.length < 2) return;
      var p = document.createElement('button'), n = document.createElement('button');
      p.type = n.type = 'button';
      p.className = 'kl-gal-btn kl-gal-prev'; n.className = 'kl-gal-btn kl-gal-next';
      p.setAttribute('aria-label', 'Vorheriges Bild'); n.setAttribute('aria-label', 'Nächstes Bild');
      p.innerHTML = ICON.replace('PATH', 'M15 5l-7 7 7 7'); n.innerHTML = ICON.replace('PATH', 'M9 5l7 7-7 7');
      Array.prototype.forEach.call(wrap.querySelectorAll('.kl-gal-btn'), function (b) { b.remove(); }); wrap.appendChild(p); wrap.appendChild(n);
      (function (b) { var sx = 0, sy = 0; b.addEventListener('pointerdown', function (e) { e.stopPropagation(); }); b.addEventListener('touchstart', function (e) { e.stopPropagation(); sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true }); b.addEventListener('touchend', function (e) { e.stopPropagation(); var t = e.changedTouches[0]; if (Math.abs(t.clientX - sx) > 12 || Math.abs(t.clientY - sy) > 12) return; e.preventDefault(); fc.previous(); }); b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); fc.previous(); }); })(p);
      (function (b) { var sx = 0, sy = 0; b.addEventListener('pointerdown', function (e) { e.stopPropagation(); }); b.addEventListener('touchstart', function (e) { e.stopPropagation(); sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true }); b.addEventListener('touchend', function (e) { e.stopPropagation(); var t = e.changedTouches[0]; if (Math.abs(t.clientX - sx) > 12 || Math.abs(t.clientY - sy) > 12) return; e.preventDefault(); fc.next(); }); b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); fc.next(); }); })(n);
      function st() { var c = fc.querySelectorAll('.product__media-item:not(.is-filtered)'), i = 0; for (var k = 0; k < c.length; k++) { if (c[k].classList.contains('is-selected')) { i = k; break; } } p.hidden = i === 0; n.hidden = i >= c.length - 1; }
      new MutationObserver(st).observe(fc, { attributes: true, subtree: true, attributeFilter: ['class'] }); st();
    });
  }
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(setup, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  window.addEventListener('load', setup);
})();

/* KL Warenkorb (UpCart): „Bewertungen“ + Ersparnis-Zeile unter Gesamtsumme (18.10.2026) */
(function () {
  var busy = false, timer = null;
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function root() { return window.upcartDocumentOrShadowRoot || null; }
  function render() {
    var R = root(); if (!R || busy) return;
    busy = true;
    Array.prototype.forEach.call(R.querySelectorAll('.upcart-public-component-upsell-tile__reviews'), function (e) {
      if (/reviews?/i.test(e.textContent)) e.textContent = e.textContent.replace(/reviews?/i, 'Bewertungen');
    });
    var p = window.upcartGetCart ? Promise.resolve(window.upcartGetCart()) : Promise.resolve(null);
    p.then(function (cart) {
      if (!cart || !cart.items) return;
      var lines = 0, save = 0;
      cart.items.forEach(function (it) {
        var q = it.quantity || 1;
        lines += it.finalLinePrice || 0;
        var cmp = Math.max(it.compareAtPrice || 0, it.originalPrice || 0);
        if (cmp > (it.finalPrice || 0)) save += (cmp - it.finalPrice) * q;
      });
      if (typeof cart.total === 'number' && lines > cart.total) save += lines - cart.total;
      var sub = null;
      Array.prototype.some.call(R.querySelectorAll('div, p'), function (e) {
        if (e.children.length <= 4 && /Gesamtsumme/.test(e.textContent) && e.textContent.length < 60 && e.offsetHeight > 0) { sub = e; return true; }
      });
      if (!sub) { var cbc = R.querySelector('.upcart-checkout-button-container'); if (!cbc) return; var row0 = R.getElementById('kl-save-row') || document.createElement('div'); row0.id = 'kl-save-row'; if (row0.nextElementSibling !== cbc) cbc.parentNode.insertBefore(row0, cbc); sub = row0.previousElementSibling || row0; if (sub === row0) { sub = document.createElement('span'); cbc.parentNode.insertBefore(sub, row0); } }
      while (sub.parentElement && sub.parentElement.textContent.trim().length < 60 && /Gesamtsumme/.test(sub.parentElement.textContent)) sub = sub.parentElement;
      var row = R.getElementById('kl-save-row');
      if (save <= 0) { if (row) row.remove(); return; }
      if (!row) { row = document.createElement('div'); row.id = 'kl-save-row'; }
      if (row.previousElementSibling !== sub) sub.parentNode.insertBefore(row, sub.nextSibling);
      var html = '<span>Du sparst:</span><span class="kl-save-val">' + eur(save) + '</span>';
      if (row.innerHTML !== html) row.innerHTML = html;
    }).catch(function () {}).then(function () { busy = false; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 250); }
  function hook() {
    var R = root(); if (!R) return false;
    if (!R.getElementById('kl-save-css')) {
      var s = document.createElement('style'); s.id = 'kl-save-css';
      s.textContent = '#kl-save-row{display:flex;justify-content:space-between;align-items:center;margin:10px 0 12px;font-weight:500}' +
        '#kl-save-row .kl-save-val{background:#fde4ec;color:#c2185b;padding:3px 8px;border-radius:6px;font-weight:700}' +
        '.upcart-public-component-upsell-tile [class*="__star"], .upcart-public-component-upsell-tile [class*="__star"] *{color:#F8BE00 !important}';
      R.appendChild(s);
    }
    new MutationObserver(function (m) {
      if (busy) return;
      if (m.every(function (x) { return x.target && x.target.closest && x.target.closest('#kl-save-row'); })) return;
      schedule();
    }).observe(R, { childList: true, subtree: true, characterData: true });
    ['upcartSubscribeCartUpdated', 'upcartSubscribeCartLoaded', 'upcartSubscribeCartOpened'].forEach(function (f) { try { if (window[f]) window[f](schedule); } catch (e) {} });
    schedule();
    return true;
  }
  var tries = 0;
  (function wait() { if (!hook() && tries++ < 80) setTimeout(wait, 250); })();
})();

/* KL Spar-Sets: Kacheln mit Farbauswahl wie beim Trio, für alle Komplett-Sets (19.10.2026) – Styles in custom.css (.kl-set) */
(function () {
  if (location.pathname.indexOf('/products') === -1) return;
  var HEX = { 'Midnight Black': '#1d1d1d', 'Schwarz': '#1d1d1d', 'Weiß': '#f3f2ee', 'Stone Grey': '#7f7f7b', 'Cashmere Flow': '#c4b2a0', 'Mint Mellow': '#a7d6be', 'Dusty Rose': '#e2a7b3', 'Blue Heaven': '#63c0e6', 'Spicy Red': '#b1232b',
    'Knusperliebe Mix': 'linear-gradient(135deg,#f08a3c 50%,#8a9a6c 50%)', 'Color Mix': 'conic-gradient(#2f6fd0 0 33%,#e8d21d 0 66%,#c8283a 0)', 'Spring Collection': 'conic-gradient(#f08a3c 0 33%,#5aa646 0 66%,#e8c31d 0)' };
  var CHEV = '<svg width="9" height="9" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 3.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var open = null, busy = false;

  function productJson() { return PJ; }
  /* Produktdaten direkt laden (/products/<handle>.js) – die Seite enthält nicht alle Varianten */
  var PJ = null, pjBusy = false;
  function loadPJ(cb) {
    if (PJ) { cb(); return; }
    if (pjBusy) return;
    pjBusy = true;
    var h = (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
    fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.variants && j.options) { PJ = j; cb(); } else pjBusy = false;
    }).catch(function () { pjBusy = false; });
  }
  function picker() { return document.querySelector('.product__info variant-picker'); }
  function inputs(pos) { var v = picker(); return v ? v.querySelectorAll('input[data-option-position="' + pos + '"]') : []; }
  function labelOf(inp) { return document.querySelector('label[for="' + inp.id + '"]'); }
  function opts(pos) {
    var out = [];
    Array.prototype.forEach.call(inputs(pos), function (inp) {
      var l = labelOf(inp); if (!l) return;
      var sw = inp.closest('.block-swatch');
      out.push({ value: l.textContent.trim(), input: inp, label: l, checked: inp.checked, soldout: !!(sw && sw.classList.contains('is-disabled')) });
    });
    return out;
  }
  function current(pos) { var o = opts(pos).filter(function (x) { return x.checked; })[0]; return o ? o.value : null; }
  function dot(c, img) {
    var bg = HEX[c] ? 'background:' + HEX[c] : (img ? 'background:#fff url(' + img + ') center/cover' : 'background:#ccc');
    return '<span class="kl-set__dot" style="' + bg + '"></span>';
  }

  /* Kachel → Set-Option finden: Bildkarte nach Varianten-ID, Bildkarte nach Farbname oder über den Namen */
  function optName(o) { return (o && o.name) || String(o); }
  function optValues(pj, oi) { var o = pj.options[oi]; if (o && o.values) return o.values; var s = {}; pj.variants.forEach(function (v) { s[v.options[oi]] = 1; }); return Object.keys(s); }
  function mapTile(it, pj, used) {
    var img = it.querySelector('img'), m = null;
    if (img && img.dataset.imgs) { try { m = JSON.parse(img.dataset.imgs); } catch (e) {} }
    var oi, vals;
    if (m) {
      for (oi = 0; oi < pj.options.length; oi++) {
        if (used[oi]) continue;
        var byVal = {}, ok = true, n = 0;
        pj.variants.forEach(function (v) {
          var u = m[String(v.id)]; if (!u) return;
          var k = v.options[oi];
          if (byVal[k] === undefined) { byVal[k] = u; n++; } else if (byVal[k] !== u) ok = false;
        });
        if (ok && n > 1) return { pos: oi + 1, imgs: byVal };
      }
      for (oi = 0; oi < pj.options.length; oi++) {
        if (used[oi]) continue;
        vals = optValues(pj, oi);
        var hit = vals.filter(function (x) { return m[x]; });
        if (hit.length > 1) { var im = {}; vals.forEach(function (x) { if (m[x]) im[x] = m[x]; }); return { pos: oi + 1, imgs: im }; }
      }
    }
    var tn = (it.querySelector('.kl-inbox__n') || {}).textContent || '';
    tn = tn.toLowerCase();
    for (oi = 0; oi < pj.options.length; oi++) {
      if (used[oi]) continue;
      var on = optName(pj.options[oi]).replace(/^farbe\s*/i, '').toLowerCase();
      if (on && tn.indexOf(on.split(' ')[0]) !== -1) return { pos: oi + 1, imgs: {} };
    }
    return null;
  }

  function enhance(box) {
    var pj = productJson(); if (!pj) return;
    box.dataset.klSet = '1';
    box.classList.add('kl-set');
    document.documentElement.classList.add('kl-set-on');
    var h = box.querySelector('.kl-inbox__h');
    if (h) h.outerHTML = '<div class="kl-set__intro"><p class="kl-set__title">Stell dir dein Set zusammen</p><p class="kl-set__text">' + (box.dataset.hint || 'Tippe bei einem Teil auf die Farbe und wähle deine Lieblingsfarbe.') + '</p></div>';
    var items = box.querySelector('.kl-inbox__items');
    var panel = document.createElement('div');
    panel.className = 'kl-set__panel'; panel.hidden = true;
    panel.innerHTML = '<div class="kl-set__panel-head"><strong></strong><button type="button" class="kl-set__close">Schließen</button></div><div class="kl-set__swatches" role="radiogroup"></div>';
    items.parentNode.insertBefore(panel, items.nextSibling);
    panel.querySelector('.kl-set__close').addEventListener('click', function () { close(box); });
    var used = {};
    Array.prototype.forEach.call(box.querySelectorAll('.kl-inbox__item'), function (it, idx) {
      var info = mapTile(it, pj, used);
      if (!info) { it.classList.add('kl-set__fixed'); return; }
      used[info.pos - 1] = 1;
      info.word = /^farbe/i.test(optName(pj.options[info.pos - 1])) ? 'Farbe' : 'Ausführung';
      it._kl = info; it._img = it.querySelector('img'); it.dataset.pos = info.pos;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kl-set__chip'; b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () { toggle(box, it, idx); });
      it.appendChild(b);
    });
    var all = true;
    for (var k = 0; k < pj.options.length; k++) { if (!used[k] && optValues(pj, k).length > 1) all = false; }
    if (!all) document.documentElement.classList.remove('kl-set-on');
    render(box);
  }

  function render(box) {
    Array.prototype.forEach.call(box.querySelectorAll('.kl-inbox__item'), function (it) {
      var info = it._kl; if (!info) return;
      var c = current(info.pos) || Object.keys(info.imgs)[0];
      if (info.imgs[c] && it._img.getAttribute('src') !== info.imgs[c]) it._img.src = info.imgs[c];
      it._img.alt = it.querySelector('.kl-inbox__n').textContent + ' in ' + c;
      var b = it.querySelector('.kl-set__chip');
      if (b.dataset.c !== c) { b.dataset.c = c; b.innerHTML = '<span class="kl-set__cl">' + dot(c, info.imgs[c]) + '<span class="kl-set__c">' + c + '</span></span><span class="kl-set__ch">Ändern ' + CHEV + '</span>'; }
      b.setAttribute('aria-label', (info.word || 'Farbe') + ' ändern, aktuell ' + c);
      b.setAttribute('aria-expanded', open === it ? 'true' : 'false');
      it.classList.toggle('is-open', open === it);
    });
  }

  function toggle(box, it, idx) {
    if (open === it) { close(box); return; }
    open = it;
    var panel = box.querySelector('.kl-set__panel');
    var info = it._kl, name = it.querySelector('.kl-inbox__n').textContent;
    panel.querySelector('strong').textContent = (info.word || 'Farbe') + ' für ' + name + ' wählen';
    var n = box.querySelectorAll('.kl-inbox__item').length;
    panel.style.setProperty('--kl-arrow', ((idx + 0.5) / n * 100) + '%');
    var sw = panel.querySelector('.kl-set__swatches'); sw.innerHTML = '';
    opts(info.pos).forEach(function (o) {
      var s = document.createElement('button');
      s.type = 'button'; s.className = 'kl-set__sw' + (o.soldout ? ' is-soldout' : '');
      s.setAttribute('role', 'radio'); s.setAttribute('aria-checked', o.checked ? 'true' : 'false');
      var im = info.imgs[o.value];
      s.innerHTML = '<span class="kl-set__thumb">' + (im ? '<img src="' + im + '" alt="" loading="lazy">' : dot(o.value)) + '</span><small>' + o.value + (o.soldout ? '<em>ausverkauft</em>' : '') + '</small>';
      s.addEventListener('click', function () { pick(box, it, o.value); });
      sw.appendChild(s);
    });
    panel.hidden = false;
    render(box);
  }

  function pick(box, it, value) {
    var o = opts(it._kl.pos).filter(function (x) { return x.value === value; })[0];
    open = null;
    box.querySelector('.kl-set__panel').hidden = true;
    if (o && !o.checked) { busy = true; o.label.click(); busy = false; }
    render(box);
    it.classList.remove('is-flash'); void it.offsetWidth; it.classList.add('is-flash');
  }

  function close(box) { open = null; var p = box.querySelector('.kl-set__panel'); if (p) p.hidden = true; render(box); }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) { var b = document.querySelector('.kl-inbox.kl-set'); if (b) close(b); } });

  function run() {
    if (location.pathname.indexOf('/products/') === -1 || !document.querySelector('.kl-inbox:not([data-kl-set])')) { var b0 = document.querySelector('.kl-inbox.kl-set'); if (b0 && !busy) render(b0); return; }
    loadPJ(function () { Array.prototype.forEach.call(document.querySelectorAll('.kl-inbox:not([data-kl-set])'), enhance); });
    var b = document.querySelector('.kl-inbox.kl-set'); if (b && !busy) render(b);
  }
  var t = null;
  new MutationObserver(function () { if (busy) return; clearTimeout(t); t = setTimeout(run, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('variant:changed', function () { setTimeout(run, 30); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
